import { render, staticRenderFns } from "./ErrorNumbers.vue?vue&type=template&id=f022bf34&scoped=true&"
import script from "./ErrorNumbers.vue?vue&type=script&lang=js&"
export * from "./ErrorNumbers.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNumbers.vue?vue&type=style&index=0&id=f022bf34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f022bf34",
  null
  
)

export default component.exports